import type { ComponentPropsWithoutRef } from "react";
import { classNames } from "@/react/helpers/twMergeWithCN";

export interface CanvasProps extends ComponentPropsWithoutRef<"div"> {}

export const Canvas = ({ className, children, ...rest }: CanvasProps) => (
  <div
    className={classNames(
      "divide-primary flex h-full flex-col gap-6 overflow-y-auto [grid-area:canvas]",
      className,
    )}
    data-testid="builder-ui-canvas"
    data-builder-ui-dnd-collision-detection-container
    {...rest}
  >
    {children}
  </div>
);
